module.exports = __webpack_public_path__ + "img/IMG_0695.dc2506c6.jpg";